export default __webpack_public_path__ + "static/media/marvel.f64c057b.svg";